<template>
  <div class="box-outer">
    <label :for="`id_${name}`" class="label">
      {{ label }}
    </label>
    <div class="fields-wrap">
      <div class="field">
        <date-component
          v-if="filled"
          :placeholder="$t('choose-date')"
          :disabled-dates="disabledDates"
          v-model="date"
          name="contact-date"
          @input="handleDate"
        />
        <date-component
          v-if="!filled"
          :placeholder="$t('choose-date')"
          :disabled-dates="disabledDates"
          :class="{ 'input-error': errors }"
          v-model="date"
          name="contact-date"
          @input="handleDate"
        />
      </div>
      <div class="field">
        <text-component
          ref="time"
          v-model="time"
          class="time"
          name="contact-hours"
          type="time"
          placeholder="12:00"
          @input="handleTime"
        />
      </div>
    </div>
    <error-component :errors="errors" />
  </div>
</template>

<script>
import ErrorComponent from '@/components/Error'
import DateComponent from '@/components/form/fields/Date'
import TextComponent from '@/components/form/fields/Text'

export default {
  components: {
    ErrorComponent,
    DateComponent,
    TextComponent
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    errors: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    },
    filled: {
      type: Boolean,
      default: false
    },
    disabledDates: {
      type: [Boolean, Object],
      default() {
        return {
          from: new Date()
        }
      }
    }
  },
  data() {
    return {
      date: '',
      time: this.filled ? '10:00' : '',
      focused: false
    }
  },
  mounted() {
    if (this.filled) {
      const today = new Date()
      this.date = new Date(today.setDate(today.getDate() + 1))
      this.handleDate()
    }
  },
  methods: {
    convertToOneDateTime(date, time) {
      const both = new Date()
      const timeSplit = time.split(':')

      if (time) {
        both.setHours(timeSplit[0])
        both.setMinutes(timeSplit[1])
        both.setSeconds('00')
      }

      if (date) {
        both.setDate(date.getDate())
        both.setMonth(date.getMonth())
        both.setFullYear(date.getFullYear())
      }
      if (date && !time) {
        both.setHours(0, 0, 0, 0)
        this.time = '00:00'
      }

      return both
    },
    handleDate() {
      this.$emit('input', {
        value: this.convertToOneDateTime(this.date, this.time),
        date: this.date,
        time: this.time
      })
    },
    handleTime() {
      this.$emit('input', {
        value: this.convertToOneDateTime(this.date, this.time),
        date: this.date,
        time: this.time
      })
      this.focused = true
    }
  }
}
</script>

<style lang="scss" scoped>
.box-outer {
  margin: 28px 0 0;
}

.label {
  @include label;
}

.fields-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.field {
  width: calc(50% - 8px);

  @media (max-width: 539px) {
    width: 100%;
    &:last-of-type {
      margin-top: 16px;
    }
  }
}

.time {
  position: relative;

  &--safari {
    &::after {
      pointer-events: none;
      content: attr(data-placeholder);
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-25%);
      left: 18px;
      @include placeholder;
      font-size: 18px;
    }
  }
}

.input-error {
  border: 2px solid $error;
}
</style>
